import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: `${process.env.VUE_APP_COMMON_URL}/v1/hyper-common/profile`,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}

const service = {
    resetPassword ({ email }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put('/users/password/reset', { email })
    },
    signAgreement ({ userIdx, signedTc }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.put(`/users/${userIdx}/signed-tc`, { userIdx, signedTc })
    }
}
export {
    service,
    overrideConfig,
    useAuth
}
